/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Select_Min_OneInputs */

const vi_order_export_select_min_one = /** @type {(inputs: Order_Export_Select_Min_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất 1 giá trị`)
};

/**

* @param {Order_Export_Select_Min_OneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_select_min_one = /** @type {((inputs?: Order_Export_Select_Min_OneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Select_Min_OneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_select_min_one(inputs)
});